import rainforestLogo from "/img/integration/rainforest.png"
import { ConnectEmailPage } from "../connect-email-page"

export function ConnectRainforestPage() {
  return (
    <ConnectEmailPage
      logo={rainforestLogo}
      logoAlt="Rainforest"
      integrationName="rainforest"
      description="Rainforest sends deduction and dispute information via email. Connect the email account(s) that receive Rainforest communications."
      redirectTo="/setup/config/rainforest"
    />
  )
}
